import type { CurveType } from "@mui/x-charts/models";

export const CHART_HEIGHT = 300;

export const CHART_UNAVAILABLE_TEXT = "Chart unavailable";

export const LINE_CURVE: CurveType = "linear";

export const NO_LINE_DASH = "5 3";

export const DOTTED_LINE_DASH = "3 4";

export const DOTTED_LINE_WIDTH = 1.5;

export const CONSENSUS_LINE_WIDTH = 2.5;

export const Y_AXIS_MIN = 0;

export const Y_AXIS_MAX = 100;

export const Y_AXIS_TICK_COUNT = 6;

export const Y_AXIS_TICKS = Array.from(
  { length: Y_AXIS_TICK_COUNT },
  (_, index) =>
    Y_AXIS_MIN + ((Y_AXIS_MAX - Y_AXIS_MIN) / (Y_AXIS_TICK_COUNT - 1)) * index
);

export const TICK_FONT_SIZE = 11;

export const NO_DATA_FONT_SIZE = 12;

export const CURSOR_HINT_FONT_SIZE = 10;

export const DEFAULT_LINE_WIDTH = 2;

export const PAST_LINE_EXTRA_WIDTH = 0.5;

export const FUTURE_LINE_OPACITY = 0.28;

export const LINE_PAST_CLASS = "line-past";

export const LINE_FUTURE_CLASS = "line-future";

export const CURSOR_HINT_TOP = 10;

export const WATERMARK_WIDTH = "70%";

export const WATERMARK_MAX_WIDTH = 280;

export const WATERMARK_OPACITY = 0.05;

export const WATERMARK_TOP = "60%";
